export interface ISearchVinResult {
	data: IVinData;
	licensePlate?: string;
	state?: string;
}

export interface IVinData {
	year: number;
	makeId: number;
	modelId: number;
	trims?: IVinTrimsEntity[] | null;
}
export interface IVinTrimsEntity {
	id: number;
	trimName: string;
}

export interface IVehicleYearsResult {
	data?: number[] | null;
}

export interface IVehicleMakesResult {
	data?: IVehicleMakesDataEntity[] | null;
}
export interface IVehicleMakesDataEntity {
	id: number;
	makeName: string;
}

export interface IVehicleModelsResult {
	data?: IVehicleModelsDataEntity[] | null;
}
export interface IVehicleModelsDataEntity {
	kbbModelId: number;
	make: IVehicleMake;
	id: number;
	modelName: string;
}
export interface IVehicleMake {
	id: number;
	makeName: string;
}

export interface IVehicleTrimsResult {
	data?: IVehicleTrimsDataEntity[] | null;
}

export interface IVehicleTrimsDataEntity {
	kbbModelId: number;
	trimName: string;
	id: number;
	year: number;
	modelId: number;
	vehicleClass: string;
}

export interface IVehicle {
	year?: number;
	makeId?: number;
	vin?: string;
	licensePlate?: string;
	modelId?: number;
	trimId?: number;
	odometer?: string;
	makeStr?: string;
	modelStr?: string;
	trimStr?: string;
	vehicleOwnershipStatus?: string;
	source?: string;
	vendorVehicleId?: number;
	isFinalVehicle?: boolean;
}

export interface IIneligibleVehicleResult {
	inValidVehicleTrimIds?: number[];
	inValidVehicleModelIds?: number[];
	inValidVehicleMakeIds?: number[];
}

export interface IVehicleListResponse {
	success: boolean;
	vehicles: IVehicleListEntity[];
}

export interface IVehicleListEntity {
	vin: string;
	modelYear: number;
	makeText: string;
	modelText: string;
	vendorName: string;
	vendorVehicleId: number;
}

export interface IVinInformation {
	vin: string;
	vinResults: ISearchVinResult;
}

export interface IVehicleDialogData extends IVinInformation {
	vendorName: string;
	vendorVehicleId: number;
}

export interface ILicensePlateRequest {
	plate: string;
	state: string;
}

export interface ILicensePlateResponse {
	success: boolean;
	vehicle: ILicensePlateVehicle;
}

export interface ILicensePlateVehicle {
	year: number;
	makeId: number;
	modelId: number;
	trims: IVinTrimsEntity[];
	vendorName: string;
	vendorVehicleId: number;
	vin: string;
}

export interface IVehicleVendorInformation {
	vendorName: string;
	vendorVehicleId: number;
}

export enum TitleTypeEnum {
	paper = 'PAPER',
	electronic = 'ELECTRONIC'
}

export enum VehicleSourceEnum {
	vinGateway = 'VG',
	carFax = 'CF',
	vin = 'VIN',
	manual = 'MANUAL'
}

export const ElectronicTitleEnabledStates = ['FL', 'AZ'];
